module.exports = __webpack_public_path__ + "static/assets/2fd63da15cc33ed10b055a5f49fa3d9a.svg";